import React from 'react'

import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'

interface ChipProps {
  children: React.ReactNode;
  className?: string;
  to?: string;
  variant?: 'default' | 'category' | 'tag';
  size?: 'small' | 'medium' | 'large';
}

const Chip: React.FC<ChipProps> = ({ 
  children, 
  className, 
  to, 
  variant = 'default',
  size = 'medium'
}) => {
  const chipClasses = cn(
    styles.chip,
    styles[`chip--${variant}`],
    styles[`chip--${size}`],
    className
  )

  if (to) {
    return (
      <Link to={to} className={chipClasses}>
        {children}
      </Link>
    )
  }

  return (
    <span className={chipClasses}>
      {children}
    </span>
  )
}

export default Chip
